import { Pipe, PipeTransform } from '@angular/core';

/**
 * Renders the server-derived `login_method` key as a human-friendly label.
 *
 * The backend emits lowercase keys (whatsapp | sms | call | phone | apple |
 * email | facebook | unknown) derived from how the account authenticated:
 * phone signups are split by their OTP channel, and no-phone Firebase accounts
 * (Apple Sign-In on iOS) are labelled Apple. Unknown/blank values render as
 * an em dash so the column reads cleanly.
 */
const LABELS: Record<string, string> = {
  whatsapp: 'WhatsApp',
  sms: 'SMS',
  call: 'Call',
  phone: 'Phone',
  apple: 'Apple',
  email: 'Email',
  facebook: 'Facebook',
  google: 'Google',
  unknown: '—',
};

@Pipe({
  name: 'loginMethodLabel',
  standalone: true,
})
export class LoginMethodLabelPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    const key = String(value ?? '').trim().toLowerCase();
    if (!key) {
      return '—';
    }
    return LABELS[key] || (key.charAt(0).toUpperCase() + key.slice(1));
  }
}
